// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1IaYg","signatureButtonsRight":"ModalSign_signatureButtonsRight__1bvHp"};